import Home from "../pages/Home/Home";
import Contact from "../pages/Contact/Contact";
import Services from "../pages/Services/Services";
import About from "../pages/About/About";
import Project from "../pages/Project/Project";

function Route() {
  return (
    <main>
      <Home />
      <Services />
      <Project />
      <About />
      <Contact />
    </main>
  );
}

export default Route;
